import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Saguaro } from "@/components/Saguaro";
import { Button } from "@/components/ui/button";

export default function BookingCancelled() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-card rounded-2xl shadow-sm p-8 md:p-10 text-center" data-testid="booking-cancelled-card">
        <Link to="/" className="flex items-center justify-center gap-2 font-serif text-2xl font-semibold text-foreground mb-8">
          <Saguaro className="h-7 w-7 text-primary" /> The East Valley
        </Link>
        <XCircle className="h-16 w-16 text-muted-foreground mx-auto mb-5" />
        <h1 className="font-serif text-3xl font-semibold text-foreground mb-2">Booking cancelled</h1>
        <p className="text-muted-foreground mb-6">No worries — your dates weren't charged. You can pick up right where you left off.</p>
        <Button asChild className="rounded-full bg-primary w-full h-11"><Link to="/#book">Back to booking</Link></Button>
      </div>
    </div>
  );
}
